/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql, withPrefix } from "gatsby"
import removeHtmlTags from "~utils/remove-html-tags"

function SEO({ description, unlisted, excludeFromSearch, lang, meta, title, label, path }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  )

  const indexingRule =
    unlisted || excludeFromSearch
      ? {
          name: `robots`,
          content: `noindex`,
        }
      : {}

  const socialMeta = {
    title: `${title} ${label ? `| ${label} |` : `|`} ${site.siteMetadata.title}`,
    description: removeHtmlTags(description || site.siteMetadata.description || ``),
    image: `https://developer.fastly.com/social-card/?title=${title}`,
    // image: site.siteMetadata.siteUrl + withPrefix(`/social-card/?title=${title}`),
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s ${label ? ` | ${label} | ` : ` | `} ${site.siteMetadata.title}`}
      meta={["og", "twitter"]
        .reduce((acc, ns) => {
          for (const [key, value] of Object.entries(socialMeta)) {
            acc.push({
              [ns === "twitter" ? "name" : "property"]: `${ns}:${key}`,
              content: value,
            })
          }
          return acc
        }, [])
        .concat([
          {
            name: `description`,
            content: socialMeta.description,
          },
          // Twitter social sharing metadata
          {
            name: `twitter:creator`,
            content: site.siteMetadata.author,
          },
          {
            name: `twitter:card`,
            content: `summary_large_image`,
          },
          {
            name: `twitter:image`,
            content: socialMeta.image,
          },
          // OpenGraph (Facebook) social sharing metadata
          {
            property: `og:type`,
            content: `website`,
          },
          {
            name: `og:image`,
            content: socialMeta.image,
          },
          {
            name: `og:image:width`,
            content: 1200,
          },
          {
            name: `og:image:height`,
            content: 630,
          },
          indexingRule,
        ])
        .concat(meta)}
    ></Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  path: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
}

export default SEO
